import Head from "next/head";

interface HeadTags {
  title: string;
  canonical: string;
  metaTags?: {
    name: string;
    content: string;
  }[];
  schema?: any;
}

export function withSeoHeadTags(component: JSX.Element, headTags: HeadTags) {
  return (
    <>
      <Head>
        <title>{headTags?.title || "Travel Insurance - MakeMyTrip"}</title>

        {headTags?.metaTags?.map((metaTag, index) => {
          if (metaTag.name && metaTag.content) {
            return (
              <meta key={index} name={metaTag.name} content={metaTag.content} />
            );
          }
        })}

        {headTags?.schema?.map((schema) => {
          return (
            <script
              type="application/ld+json"
              dangerouslySetInnerHTML={{
                __html: JSON.stringify(schema),
              }}
            />
          );
        })}

        {headTags?.canonical ? (
          <link rel="canonical" href={headTags.canonical} />
        ) : null}
      </Head>
      {component}
    </>
  );
}
